import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "form-custom col-lg-6 mt-5" }
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = {
  class: "p-field-label",
  for: "name"
}
const _hoisted_5 = {
  for: "name",
  class: "fs-13 label-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.Name")), 1),
        _createVNode(_component_InputText, {
          id: "name",
          type: "text",
          class: ["w-100", { 'input-error': !_ctx.isValidName }],
          disabled: _ctx.isDefaultScene(_ctx.scene),
          modelValue: _ctx.scene.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.scene.name = $event))
        }, null, 8, ["class", "disabled", "modelValue"]),
        _createVNode("label", _hoisted_5, _toDisplayString(_ctx.invalidNameReason), 1)
      ])
    ])
  ]))
}